<template>
  <div>
    <!-- <el-row :gutter="10">
  <el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="1"><div class="grid-content bg-purple"></div></el-col>
  <el-col :xs="4" :sm="6" :md="8" :lg="9" :xl="11"><div class="grid-content bg-purple-light"></div></el-col>
  <el-col :xs="4" :sm="6" :md="8" :lg="9" :xl="11"><div class="grid-content bg-purple"></div></el-col>
  <el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="1"><div class="grid-content bg-purple-light"></div></el-col>
</el-row> -->
<!-- {{shipmentDate}}
{{mawbList}} -->
    <!--Stats cards-->
  <el-row :gutter="10">
    <el-col :xs="14" :sm="7" :md="8" :lg="5" :xl="4">
      <div class="grid-content bg-purple">
      <el-date-picker
        v-model="shipmentDate"
        type="date"
        format="dd/MM/yyyy"
        value-format="yyyy-MM-dd"
        placeholder="Pick a shipment date"
        :picker-options="pickerOptions1"
        @change="onChangeShipmentDate"
        :disabled="isLoading === true"
        >
      </el-date-picker>
      </div>
    </el-col>
    <el-col :xs="10" :sm="6" :md="8" :lg="5" :xl="4">
      <div class="grid-content bg-purple-light">
        <el-select v-model="selectedMAWB" :disabled="isLoading === true" placeholder="Select MAWB" clearable @change="onChangeMawb">
          <el-option
            v-for="option in mawbList"
            :value="option.mawb"
            :label="`${option.customer ? option.customer+' | ' : ''}${option.vessel && option.vessel+ ' /' } ${option.mawb}`"
            :key="option.mawb"
            >
          </el-option>
        </el-select>
        <span class="loading" v-show="isLoading === true" ><i class="el-icon-loading"></i></span>
      </div>
    </el-col>
    <el-col :xs="10" :sm="10" :md="8" :lg="14" :xl="16" class="refresh-btn">
      <div class="grid-content bg-purple pull-right">
        <!-- <div class="stats btn-refresh" @click="refresh" :class="`${isLoading ? 'refresh-disabled' : ''}`">
          <i class="nc-icon nc-refresh-69"></i> Update Now
        </div> -->

        <el-button
        type="primary"
        plain
        style="padding: 4px;font-size: 24px;"
        :disabled="isLoading"
        :icon="`${isLoading ? 'el-icon-loading' : 'el-icon-refresh'}`"
        @click="refresh()">
        </el-button>
      </div>
    </el-col>
  </el-row>

  <!-- <div class="block"> -->
    <!-- <span class="demonstration">Shipment Date: </span>
    <el-date-picker
      v-model="shipmentDate"
      type="date"
      format="dd/MM/yyyy"
      value-format="yyyy-MM-dd"
      placeholder="Pick a day"
      :picker-options="pickerOptions1"
      @change="onChangeShipmentDate"
      :disabled="isLoading === true"
      >
    </el-date-picker>

    <el-select v-model="selectedMAWB" :disabled="isLoading === true" placeholder="Select MAWB" clearable @change="onChangeMawb">
      <el-option
        v-for="option in mawbList"
        :value="option.mawb"
        :label="`${option.vessel && option.vessel+ ' /' } ${option.mawb}`"
        :key="option.mawb"
        >
      </el-option>
    </el-select>

    <span class="loading" v-show="isLoading === true" ><i class="el-icon-loading"></i></span> -->

    <!-- <div class="pull-right">
      <div class="stats btn-refresh" @click="refresh" :class="`${isLoading ? 'refresh-disabled' : ''}`">
        <i class="nc-icon nc-refresh-69"></i> Update Now
      </div>
    </div> -->
  <!-- </div> -->
  <hr>
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-6" v-for="(stats, key) in statsCards.head" :key="key">
        <stats-card :type="stats.type"
                    :icon="stats.icon"
                    :small-title="stats.title"
                    :title="stats.value"
                    :disableType="stats.disableType"
                    :enableFormat="stats.enableFormat">
          <!-- <div class="stats" slot="footer" @click="refresh">
            <i :class="stats.footerIcon"></i>
            {{stats.footerText}}
          </div> -->
        </stats-card>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-6" v-for="(stats, key) in statsCards.body" :key="key">
        <stats-card :type="stats.type"
                    :icon="stats.icon"
                    :small-title="stats.title"
                    :title="stats.value"
                    :disableType="stats.disableType"
                    :green="stats.green"
                    :red="stats.red"
                    :ready="stats.ready"
                    :hold="stats.hold"
                    :released="stats.released"
                    :over="stats.over"
                    :noShow="stats.noShow"
                    :unmanifest="stats.unmanifest"
                    :catFour="stats.catFour"
                    >
          <!-- <div class="stats" slot="footer" @click="refresh">
            <i :class="stats.footerIcon"></i>
            {{stats.footerText}}
          </div> -->
        </stats-card>
      </div>
    </div>

  </div>
</template>
<script>
import Vue from "vue"
import axios from "axios"
import * as _apiDashboard from "@/api/dashboard"
import * as _apiMAWB from "@/api/mawb"
import { mapGetters } from 'vuex'
import {
  DatePicker,
  Select,
  Option,
  Row,
  Col,
  Button
} from "element-ui"
  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard'
  import {Badge} from 'src/components/UIComponents'
  import Loading from 'src/components/Dashboard/Layout/LoadingMainPanel.vue'
  // const WorldMap = () => ({
  //   component: import('./../Maps/WorldMap.vue'),
  //   loading: Loading,
  //   delay: 200
  // })
Vue.use(DatePicker)
Vue.use(Select)
Vue.use(Option)
Vue.use(Row)
Vue.use(Col)
Vue.use(Button)

export default {
  components: {
    StatsCard,
    ChartCard,
    CircleChartCard,
    Badge,
    Loading,
  },
  data() {
    return {
      arrivalsDate: [],
      pickerOptions1: {
        disabledDate: this.disabledDueDate,
      },
      selectedMAWB: '',
      isLoading: false,
      shipmentDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, 10),
      statsCards: {
        head: [
          {
            type: 'warning',
            icon: 'nc-icon nc-globe',
            title: 'Total Shipments',
            key: 'totalShipments',
            value: '0',
            footerText: 'Updated now',
            footerIcon: 'nc-icon nc-refresh-69',
            disableType: true,
            enableFormat: false
          },
          {
            type: 'success',
            icon: 'nc-icon nc-credit-card',
            title: 'Duty',
            key: 'duty',
            value: '0',
            footerText: 'Updated now',
            footerIcon: 'nc-icon nc-refresh-69',
            disableType: true,
            enableFormat: true
          },
          {
            type: 'info',
            icon: 'nc-icon nc-bank',
            title: 'VAT',
            key: 'vat',
            value: '0',
            footerText: 'Updated now',
            footerIcon: 'nc-icon nc-refresh-69',
            disableType: true,
            enableFormat: true
          },
          {
            type: 'danger',
            icon: 'nc-icon nc-paper',
            title: 'Total Duty & VAT',
            key: 'totalDutyAndVat',
            value: '0',
            footerText: 'Updated now',
            footerIcon: 'nc-icon nc-refresh-69',
            disableType: true,
            enableFormat: true
          }
        ],
        body: [
          {
            type: 'success',
            icon: 'nc-icon nc-money-coins',
            title: 'CATEGORY 1',
            key: 'cat1',
            value: '0',
            footerText: 'Updated now',
            footerIcon: 'nc-icon nc-refresh-69',
            disableType: false,
            green: 0,
            red: 0,
            ready: 0,
            hold: 0,
            released: 0,
            over: 0,
            noShow: 0,
            unmanifest: 0,
            catFour: 0
          },
          {
            type: 'danger',
            icon: 'nc-icon nc-money-coins',
            title: 'CATEGORY 2',
            key: 'cat2',
            value: '0',
            footerText: 'Updated now',
            footerIcon: 'nc-icon nc-refresh-69',
            disableType: false,
            green: 0,
            red: 0,
            ready: 0,
            hold: 0,
            released: 0,
            over: 0,
            noShow: 0,
            unmanifest: 0,
            catFour: 0
          },
          {
            type: 'info',
            icon: 'nc-icon nc-money-coins',
            title: 'CATEGORY 3',
            key: 'cat3',
            value: '0',
            footerText: 'Updated now',
            footerIcon: 'nc-icon nc-refresh-69',
            disableType: false,
            green: 0,
            red: 0,
            ready: 0,
            hold: 0,
            released: 0,
            over: 0,
            noShow: 0,
            unmanifest: 0,
            catFour: 0
          },
          {
            type: 'info',
            icon: 'nc-icon nc-money-coins',
            title: 'Other',
            key: 'other',
            value: '0',
            footerText: 'Updated now',
            footerIcon: 'nc-icon nc-refresh-69',
            disableType: false,
            green: 0,
            red: 0,
            ready: 0,
            hold: 0,
            released: 0,
            over: 0,
            noShow: 0,
            unmanifest: 0,
            catFour: 0
          }
        ],
      },
      mawbList: []
    }
  },
  watch: {
    // shipmentDate (v) {
    //   this.selectedMAWB = ''
    //   this.$store.dispatch("$_mawb/ON_SELECTED_CHANGE", {
    //     shipmentDate: v,
    //     mawb: this.selectedMAWB
    //   })
    //   this.initialData(v, this.selectedMAWB)
    // },
    // selectedMAWB (v) {
    //   this.fetchStatsByDate(this.shipmentDate, v)
    // }
  },
  computed: {
    ...mapGetters({
      getSelected: "$_mawb/getSelected"
    }),
  },
  created () {
    this.shipmentDate = this.getSelected.shipmentDate
    this.selectedMAWB = this.getSelected.mawb
    // this.initialData(this.shipmentDate, this.selectedMAWB)
    this.getArrivalsDate()
  },
  methods: {
    initialData (date, mawbID) {
      let _date = this.formatDate(date)
      let _this = this
      // let _setMAWBList = this.setMAWBList
      let _setStats = this.setStats
      this.isLoading = true
      axios.all([_apiDashboard.getStats(_date, mawbID), _apiMAWB.getByDate(_date)])
      .then(axios.spread((dashboardStat, mawb) => {
        try {
          _setStats(dashboardStat.data)
          _this.mawbList = mawb.data
        }
        catch(err) {
          console.log(err)
        }
      }))
      .catch(error => {
        this.$notify({
          message: JSON.parse(error),
          type: 'danger'
        })
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    fetchStatsByDate (date, mawbID) {
      this.isLoading = true
      _apiDashboard.getStats(this.formatDate(date), mawbID)
      .then(response => {
        this.setStats(response.data)
      })
      .catch(error => {
        this.$notify({
          message: error.response.data.message || 'Unsuccessfully',
          type: 'danger'
        })
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    setStats (data) {
      this.statsCards.head[0].value = data.totalShipments.toString() || 0
      this.statsCards.head[1].value = data.duty.toString() || 0
      this.statsCards.head[2].value = data.vat.toString() || 0
      this.statsCards.head[3].value = data.totalDutyVat.toString() || 0

      for (let i = 0; i < this.statsCards.body.length; i++) {
        if (data.categories[i]) {
          this.statsCards.body[i].value = data.categories[i].total.toString() || 0
          this.statsCards.body[i].green = data.categories[i].green || 0
          this.statsCards.body[i].red = data.categories[i].red || 0
          this.statsCards.body[i].ready = data.categories[i].ready || 0
          this.statsCards.body[i].hold = data.categories[i].hold || 0
          this.statsCards.body[i].released = data.categories[i].released || 0
          this.statsCards.body[i].over = data.categories[i].over || 0
          this.statsCards.body[i].noShow = data.categories[i].noShow || 0
          this.statsCards.body[i].unmanifest = data.categories[i].unmanifest || 0
          this.statsCards.body[i].catFour = data.categories[i].catFour || 0
        }
      }
    },
    formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear()

        if (month.length < 2) month = '0' + month
        if (day.length < 2) day = '0' + day

        return [day, month, year].join('-')
    },
    setMAWBList (data) {
      this.mawbList = data
    },
    disabledDueDate (time){
      return this.arrivalsDate.indexOf(time.getTime()) === -1
    },
    getArrivalsDate () {
      _apiMAWB.getArrivalsDate()
      .then(res => {
        let data = res.data
        for(let i = 0; i < res.data.length; i++) {
          this.arrivalsDate.push(new Date(data[i].replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")).getTime())
        }
        // Set Shipment to last arrival date
        if (data.length > 0) {
          this.shipmentDate = data[data.length - 1].replace( /(\d{2})-(\d{2})-(\d{4})/, "$3-$2-$1")
          this.onChangeShipmentDate(this.shipmentDate)
        }
      })
      .catch(error => {
        this.$notify({
            message: 'Unsuccessfully Fetch Arrivals Date',
          type: 'danger'
        })
      })
      .finally(() => {
        this.isRefreshLoading = false
      })
    },
    onChangeShipmentDate(v) {
      this.selectedMAWB = ''
      this.$store.dispatch("$_mawb/ON_SELECTED_CHANGE", {
        shipmentDate: v,
        mawb: this.selectedMAWB
      })
      // console.log('onChangeShipmentDate')
      this.initialData(v, this.selectedMAWB)
    },
    onChangeMawb (v) {
      this.$store.dispatch("$_mawb/ON_SELECTED_CHANGE", {
        shipmentDate: this.shipmentDate,
        mawb: v
      })
      this.fetchStatsByDate(this.shipmentDate, v)
    },
    refresh () {
      // idLoading == true don't need to refresh data
      if (this.isLoading) {
        return
      }
      this.initialData(this.shipmentDate, this.selectedMAWB)
    }
  }
}

</script>
<style lang="scss" scoped>
.stats {
   cursor: pointer;
}

.loading {
  padding-left: 10px;
}

.btn-refresh {
  padding-top: 10px;
}

.refresh-disabled {
  border-color: #ebeef5;
  color: #c0c4cc;
}

.refresh-btn {
  display: block;
  @media screen and (max-width: 1024px) {
    display: none;
  }
}
  // .el-col {
  //   border-radius: 4px;
  // }
  // .bg-purple-dark {
  //   background: #99a9bf;
  // }
  // .bg-purple {
  //   background: #d3dce6;
  // }
  // .bg-purple-light {
  //   background: #e5e9f2;
  // }
  // .grid-content {
  //   border-radius: 4px;
  //   min-height: 36px;
  // }
</style>
